import i18next from 'i18next';
import { DeviceErrorCodes } from 'src/constants/deviceConstants';
import { DeviceError } from 'src/store/models/Device';

export const parseDeviceDate = (date: number): string => {
  const year = Math.floor(date / 10000);
  const month = Math.floor((date / 100) % 100);
  const day = Math.floor(date % 100);
  return `${day}.${month}.${year}`;
};

export const zeroPad = (num: number, places: number): string =>
  String(num).padStart(places, '0');

export const getErrorDetails = (
  logCode: DeviceErrorCodes,
  errorCode: string,
  date: number
): DeviceError => {
  switch (logCode) {
    case DeviceErrorCodes.CLEANING_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:cleaning'),
      };
    case DeviceErrorCodes.DOOR_OPENED_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:door_opened'),
      };
    case DeviceErrorCodes.FIRE_ERROR_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:fire_error'),
      };
    case DeviceErrorCodes.CHIMNEY_DIRTY_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:chimney_dirty'),
      };
    case DeviceErrorCodes.NTC2_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:ntc2'),
      };
    case DeviceErrorCodes.NTC3_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:ntc3'),
      };
    case DeviceErrorCodes.TC2_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:tc2'),
      };
    case DeviceErrorCodes.SECURITY_SWITCH_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:security_switch'),
      };
    case DeviceErrorCodes.PRESSURE_SWITCH_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:preasure_switch'),
      };
    case DeviceErrorCodes.NTC1_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:ntc1'),
      };
    case DeviceErrorCodes.TC1_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:tc1'),
      };
    case DeviceErrorCodes.GASSES_OVER_TEMPERATURE_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t(
          'device_error_description:gasses_over_temperature'
        ),
      };
    case DeviceErrorCodes.NO_PELLETS_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:no_pellets'),
      };
    case DeviceErrorCodes.GENERAL_ERROR_CODE:
      return {
        logCode: logCode,
        errorCode,
        date: date,
        description: i18next.t('device_error_description:general_error'),
      };
    default:
      return null;
  }
};

export const addUnit = (value: number, unit: string): string => {
  return value ? `${value} ${unit}` : null;
};
